<template>
  <div class="_content">
    <!-- <div class="limit">
      支付提醒支付提醒支付提醒支付提醒支付提醒支付
      提醒支付提醒支付提醒支付提醒支付提醒支付提醒
    </div> -->
    <div class="con">
      <p>应付金额</p>
      <h1>￥<span>{{ totalPrice }}</span></h1>
      <div class="pay-type">
        <h5>请选择支付方式</h5>
        <div class="type-pay">
          <ul>
            <li v-for="(item, index) in shopBill.payModels" :key="index"><img :src="item.payLogo"/><span :class="item.payPlatformId">{{ item.payPlatform }}</span>
            <van-radio-group class="vradio" v-model="radio"><van-radio :name="item.payModelId"  @click="radioChange(item.payPlatformId)"></van-radio></van-radio-group></li>
          </ul>
        </div>
      </div>
    </div>
    <van-button round type="info" class="coll" @click="nowPay">{{ payTitle }}</van-button>
    <p class="kf">支付遇到问题？<i v-call="'400-176-8848'" style="color: #1989fa">联系客服</i></p>
    <van-popup v-model="show" :style="{width: '80%', height: '20%'}" class="wait" :close-on-click-overlay="false">
      <van-icon name="passed" color="#999" />
      <p>正在等待顾客支付（<span>{{ sec }}s</span>）...</p>
    </van-popup>
     <van-popup v-model="serd" :style="{width: '90%', height: '16%'}" class="wait" :close-on-click-overlay="false">
       <div class="serd">
       <ul>
         <li>
           <p><van-icon style="margin-bottom: 10px" name="passed" color="#1989fa" /></p>
           <span style="color: #1989fa">客户支付成功</span>
           </li>
         <li style="color: #eee">.....</li>
         <li>
           <div v-if="now">
           <p style="margin: -10px 0px 10px"><van-loading type="spinner" size="38px" color="#1989fa" style="display: inline-block" /></p>
           <span>正在创建服务单</span>
           </div>
           <div v-else>
            <p><van-icon style="margin-bottom: 10px" name="passed" color="#1989fa" /></p>
           <span>服务单创建成功</span>
           </div>
         </li>
       </ul>
       </div>
    </van-popup>
  </div>
</template>

<script>
import WxConfig from '../../../lib/commons/wxconfig'
import wx from 'weixin-js-sdk'
import Payment from '../../../lib/commons/xkPay.js'
import { Toast, Dialog, Loading } from 'vant'
import config from '@/configs/config'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
Vue.use(Loading)
export default {
  data() {
    return {
        radio: '', 
        show: false,
        sec: 20,
        serd: false,
        payTypeList: [
            {
                img: require('../../imgs/sd.png'),
                type: 'sd',
                name: '杉德'
            },
             {
                img: require('../../imgs/rx.png'),
                type: 'rx',
                name: '瑞祥'
            }
        ],
        now: true,
        dialogs: true,
        dialogs2: true,
        durations: 1000,
        duration1: 2000,
        time: 500,
        totalPrice: '',
        shopBill: {},
        orderIds: '',
        authCode: '',
        title: '',
        payModelId: '',
        orderIdN: '',
        payTitle: '',
        payPlatformId: ''

    }
  },
  created() {
    this.init()
    // this.dialog()
  },
  mounted () {
    // 调试工具
        // let vConsole = new VConsole()
    },
  computed: {},
  beforeRouteEnter(to, from, next) {
    if (to.path !== location.pathname) {
         location.assign(to.fullPath) 
    } else {
        next()
    }
},
  methods: {
    // 初始化获取数据
    init () {
      let queryList = JSON.parse(tuhu.sessionStorage.getItem('queryList'))

      this.totalPrice = queryList.goodsPriceTotal
      this.orderIds = queryList.goodsOrderId
      this.authCode = queryList.channelCode
      this.title = queryList.shopName

      this.shopBill = JSON.parse(tuhu.sessionStorage.getItem('shopBill'))
      this.radio = this.shopBill.payModels[0].payModelId
      this.payModelId = this.shopBill.payModels[0].payModelId
      this.payPlatformId = this.shopBill.payModels[0].payPlatformId
      if (this.radio === 'WXPAY') {
        this.payTitle = '立即支付'
      } else {
        this.payTitle = '立即收款'
      }
    },
    // 支付方式改变 payModelId 改变
    radioChange(payPlatformId) {
        this.payPlatformId = payPlatformId
        console.log(this.radio)
         if (this.radio === 'WXPAY') {
        this.payTitle = '立即支付'
      } else {
        this.payTitle = '立即收款'
      }
    },
    // 支付按钮
    nowPay() {
      if (this.radio === 'WXPAY') {
        this.payment()
      } else {
        this.coll()
      }
    },
    // 调用微信扫一扫
    coll () {
      let that = this // 微信扫一扫关键字
		  if (tuhu.device.isWeixin) {
      WxConfig.share(['scanQRCode']).then((status) => {
      // console.log('配置是否成功', status)
            wx.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
                // Toast.loading({
                //   message: '正在发起收款...',
                //   forbidClick: true,
                //   duration: that.duration1
                //   }) // 收款加载2s
                  setTimeout(() => {
                    if (that.time === 500) {
                      that.setOut()
                    }
                  }, that.time) // 2s后倒计时10秒
                  let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                  console.log(result, '121212')
                  tuhu.fetch(`${config.apis.PAY_UNIFIED}`, {
                  method: 'post', 
                  body: JSON.stringify({
						        authCode: result,
                    orderId: that.orderIds,
                    jumpUrl: '',
                    openid: '',
                    payModelId: that.radio,
                    payPlatformId: that.payPlatformId,
                    payPriceTotal: that.totalPrice,
                    title: that.title
					})
      }).then((data) => {
        if (data && data.code === '200') {
          // that.setOut()
          // that.show = false
          // that.dialogs = false
          // Toast.loading({
          //     message: '收款中，请勿关闭页面！',
          //     forbidClick: true,
          //     duration: that.durations
          //       }) // 查询支付状态
          if (that.sec <= 20 && that.sec > 1) {
            that.checkBill(data.data.orderId, data.data.outTradeNo)
            // const interval = setInterval(() => {
            //     that.checkBill(data.data.orderId, data.data.outTradeNo)
            //     if (that.sec === 0) {
            //       clearInterval(interval)
            //     }
            //   }, 3000)
              //  that.checkBill(data.data.orderId, data.data.outTradeNo)
          }
          // that.checkBill(data.data.orderId, data.data.outTradeNo)
          that.orderIdN = data.data.orderId
        } else {
          that.time = 1
          that.duration1 = 1
          that.show = false
          that.dialogs = false
          tuhu.toast(data.message || '网络错误')
        }
      }).catch(() => {
          that.show = false
          that.dialogs = false
          that.time = 1
          that.duration1 = 1
        setTimeout(() => {
            tuhu.toast('支付出错')
          }, 2100)
      })
        },
        fail: function (err) {
        that.show = false
        that.dialogs = false
				tuhu.toast(err || '网络错误')
          }
        })
      })
    } else {
      tuhu.toast('请在微信客户端打开')
    }
	},
  // 唤起微信支付
  payment() {
			if (tuhu.device.isWeixin) {
        let _this = this
        tuhu.wxsdk.ready()
				.then(async (res) => {
					Payment.openBank({
						  // userId: '238283928',
              signUrl: `${config.apis.PAY_UNIFIED}`,
              orderId: _this.orderIds,
              jumpUrl: '',
              openid: '',
              payModelId: _this.radio,
              payPlatformId: _this.payPlatformId,
              payPriceTotal: _this.totalPrice,
              title: _this.title
            }, true)
				})
				.catch((e) => {
					console.log('支付错误1111', e)
				})
			} else {
           tuhu.toast('请于微信公众号中发起支付！')   
			}
        },
  // 查询订单
  checkBill(orderId, outTradeNo) {
       tuhu.fetch(`${config.apis.PAY_QUERY}`, {
              method: 'post', 
              body: JSON.stringify({
              reqNo: orderId,
              outTradeNo: outTradeNo
					})
      }).then((data) => {
        if (data.data && data.code === '200') {
          this.show = false
          this.dialogs = false
          // this.durations = 100
          this.serd = true
          this.checkSerBills()
        } else {
          // this.checkBill(orderId, outTradeNo)
           const interval = setInterval(() => {
                this.checkBill(orderId, outTradeNo)
                if (this.sec === 0) {
                  clearInterval(interval)
                }
              }, 3000)
          // tuhu.toast('顾客支付失败，请重新进行收款!')
        }
      }).catch(() => {
        tuhu.toast('账单支付状态查询出错', 500)
      })
  },
  // 创建服务单
  checkSerBills() {
       tuhu.fetch(`${config.apis.SHOP_DISTR}`, {
            method: 'post', 
            body: JSON.stringify({
            goodsOrderId: this.orderIds
					})
      }).then((data) => {
        if (data && data.code === '200') {
              this.now = false
              setTimeout(() => {
                  this.navigateToBill()
              }, 200) // 跳转订单详情
        } else {
          this.dialog2()
          this.serd = false
          // tuhu.toast(data.message || '网络错误')
        }
      }).catch(() => {
        tuhu.toast('创建服务单失败')
        this.serd = false
      })
  },

  // 跳转链接
  navigateToBill() {
    tuhu.navigateTo(
          {
            url: '/pages/cashiers/billDetail',
            query: {
              orderId: this.orderIds
            }
          }
        )
  },
  // 客户收款倒计时
  setOut() {
    // this.dialog()
    this.show = true
    this.sec = 20
    const interval = setInterval(() => {
          if (this.show === true) {
          this.sec--
          if (this.sec === 0) {
            this.show = false
            clearInterval(interval)
            this.dialog()
            // this.sec = 10
          }
          } 
        }, 1000)
  },
  // 关闭支付单
  cancelPay() {
    tuhu.fetch(`${config.apis.PAY_CLOSE}`, {
              method: 'post', 
              body: JSON.stringify({
              goodsOrderId: this.orderIds
					})
      }).then((data) => {
        if (data && data.code === '200') {
          tuhu.toast('当前支付单已关闭，请重新进行收款!')
        } else {
          tuhu.toast(data.message || '网络错误')
        }
      }).catch(() => {
        tuhu.toast('关闭支付单失败')
      })
  },
  // 支付确认弹框
  dialog() {
    if (this.dialogs === true) {
    Dialog.confirm({
      title: '支付确认',
      message: '请与顾客确认支付状态：' + '\n1. 如顾客已放弃支付，请点击 [客户已放弃支付]' + '\n2. 如顾客正在支付，请点击 [等待顾客继续支付]',
      cancelButtonText: '客户已放弃支付',
      confirmButtonText: '等待顾客继续支付',
      messageAlign: 'left',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: '#1989fa'
    })
  .then(() => {
    // on confirm
    this.setOut()
  })
  .catch(() => {
    // on cancel
    this.cancelPay()
    // tuhu.toast('顾客支付失败，请重新进行收款!')
  })
    }
  },
  // 创建服务单失败提示弹框
  dialog2() {
    Dialog.confirm({
      title: '服务单创建失败',
      message: '服务单创建失败，已支付款项将退回客户支付账户，请提醒客户查看！',
      cancelButtonText: '联系客服',
      confirmButtonText: '重新下单',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: '#1989fa'
    })
  .then(() => {
    // on confirm
  })
  .catch(() => {
    // on cancel
     let deviceInfo = tuhu.device
        if (deviceInfo.iphone) {
          window.location.href = `tel://400-176-8848`
        } else {
          window.location.href = `tel:400-176-8848`
        }
  })
  } 
  }
}
</script>
<style lang="less" scoped>
.limit {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 2.3rem;
  line-height: 0.85rem;
  padding: 0.3rem 0.2rem 0.3rem 1.7rem;
  background-color: #fffbe3;
  font-size: 0.6rem;
  color: #f58542;
  &::after {
    content: "";
    position: absolute;
    width: 0.6rem;
    height: 0.6rem;
    background: url(../../imgs/image/limit-icon.png) no-repeat;
    background-size: 100%;
    top: 0.5rem;
    left: 0.8rem;
  }
}
  .con{
      width: 100%;
      background-color: #fff;
      padding: 20px 0px;
      p{
          text-align: center;
          font-size: 15px;
          margin-top: 1em;
      }
      h1{
          width: 96%;
          text-align: center;
          margin: 0.3em 0;

      }
      .pay-type{
          margin-top: 3em;
          h5{
              width: 100%;
              padding: 10px;
              background-color: #eee;
              font-size: 14px;
              color: #888;
          }
          .type-pay{
              ul li{
                  width: 100%;
                  padding: 10px;
                  font-size: 14px;
                  overflow: hidden;
                  margin-top: 1.5em;
                  font-size: 1.3em;
                  color: #1989fa;
                  img{
                      width: 30px;
                      float: left;
                      margin-right: 20px;
                  }
                  span{
                    float: left;
                    margin-top: 5px;
                  }
                  .sd{
                      margin-top: 10px;
                      float: left;
                      margin-top: 15px;
                  }
                .vradio{
                    float: right;
                }
              }
          }
      }
  }
  .coll{
      width: 200px;
      position: absolute;
      left: 50%;
      margin-left: -100px;
      font-size: 15px;
      color: #fff !important;
      bottom: 4em;
      .van-button__text{
          color: #fff !important;
      }
  }
  .kf{
      font-size: 14px;
      color: #666;
      position: absolute;
      bottom: 1em;
      left: 0px;
      width: 100%;
      text-align: center;
  }
  .wait{
    padding-top: 16px;
    text-align: center;
    font-size: 4em;
    border-radius: 10px;
    p{
      font-size: 14px;
    }
  }
  .serd{
    width: 100%;
    overflow: hidden;
    ul li{
      width: 33.33%;
      float: left;
      text-align: center;
      p{
        font-size: 0.9em;
        width: 100%;
        float: left;
      }
      span{
        font-size: 0.3em;
        width: 100%;
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashiers/index.vue